import { render, staticRenderFns } from "./InputWithMentions.vue?vue&type=template&id=282ccde5&scoped=true&"
import script from "./InputWithMentions.vue?vue&type=script&lang=ts&"
export * from "./InputWithMentions.vue?vue&type=script&lang=ts&"
import style0 from "./InputWithMentions.vue?vue&type=style&index=0&id=282ccde5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282ccde5",
  null
  
)

export default component.exports